/* eslint-disable max-len */
import { ComponentLoader } from '@galactic-advisors/component-loader';
import ExampleComponent from '@Core/components/ExampleComponent';
import Breadcrumbs from '@Core/components/Breadcrumbs';
import MarkdownEditor from '@Core/components/Fields/MarkdownEditor';
import UseIntercom from '@Core/components/useIntercom';
import InitSentry from '@Core/components/InitSentry';
import UploadFile from '@Core/components/UploadFile';
import ImplementationsForm from '@Core/components/Forms/Galactic/Implementations';
import InlineDatePicker from '@Core/components/Fields/InlineDatepicker';
import AddImplementationModal from '@Core/components/Modals/CompanyImplementations/AddImplementationModal';
import SelectFilterGroupTable from '@Core/components/Fields/Groups/SelectFilterGroupTable';
import SelectFilterGroupAutocomplete from '@Core/components/Fields/Groups/SelectFilterGroupAutocomplete';
import AddFeatureEvidenceModal from '@Core/components/Modals/CompanyFeatures/AddFeatureEvidenceModal';
import AutoAddImplementationsModal from '@Core/components/Modals/CompanyImplementations/AutoAddImplementationsModal';
import AddImplementationTemplateFeatureModal from '@Core/components/Modals/Implementations/AddImplementationTemplateFeatureModal';
import SelectFilterGroup from '@Core/components/Fields/Groups/SelectFilterGroup';
import M365AuthModal from '@Core/components/Modals/M365AuthModal';
import Datatable from '@Core/components/Datatable';
import CompanyImplementationEvidences from '@Core/components/CompanyImplementations/CompanyImplementationEvidences';
import CompanyWispGenerator from '@Core/components/CompanyWispGenerator';
import GatherFullEvidence from '@Core/components/Modals/CompanyImplementations/GatherFullEvidence';
import FileUpload from '@Core/components/FileUpload';
import ApprovalCreateForm from '@Core/components/Forms/Company/CompanyProtocol/ApprovalCreateForm';
import TrainingMassEmailAdvancedSelection from '@Core/components/Modals/Training/TrainingMassEmailAdvancedSelection';
import EasyAssessments from '../../../core/components/EasyAssessments';

window.globalComponents = new ComponentLoader(document, [
  AddImplementationTemplateFeatureModal,
  AddFeatureEvidenceModal,
  AddImplementationModal,
  ApprovalCreateForm,
  AutoAddImplementationsModal,
  Breadcrumbs,
  CompanyImplementationEvidences,
  CompanyWispGenerator,
  Datatable,
  EasyAssessments,
  FileUpload,
  GatherFullEvidence,
  InlineDatePicker,
  ExampleComponent,
  M365AuthModal,
  MarkdownEditor,
  InitSentry,
  ImplementationsForm,
  UploadFile,
  UseIntercom,
  SelectFilterGroupTable,
  SelectFilterGroupAutocomplete,
  SelectFilterGroup,
  TrainingMassEmailAdvancedSelection
]);
